//Components
import { ToastContainer as ToastifyToastContainer } from "react-toastify";
//Styles
import "./ToastContainer.module.scss";

const ToastContainer = () => {
  return <ToastifyToastContainer hideProgressBar={true} />;
};

export default ToastContainer;
